import { useEffect, useState } from 'react';

import VehicleImg from '~/assets/icons/new/vehicleDefault.svg';

import useStyles from './VehicleImageLoader.styles';

type Props = {
  src: string;
  alt?: string;
};

const VehicleImageLoader = ({
  src,
  alt = 'default-image',
}: Props): JSX.Element => {
  const { classes } = useStyles();
  const [image, setImage] = useState({ src: VehicleImg, alt });

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImage({
        src,
        alt,
      });
    };

    img.onerror = () => {};
    img.src = src;

    // Cleanup
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src, alt]);

  return (
    <img
      src={image.src}
      alt={image.alt}
      className={classes['cmn--cmp--vehicle-image-loader']}
    />
  );
};

export default VehicleImageLoader;
